import { HubService, HubServiceEvents, type IHubService } from './HubService';
import { LoggerServiceFactory } from './LoggerService';

type ElectronicIdHubBaseData = {
  code: string;
  holdingPageSigningMessage?: string;
  debugStateId?: string;
};

export type AudkenniAppHubData = ElectronicIdHubBaseData & {};
export type PkiSimHubData = ElectronicIdHubBaseData & {
  phoneNumber: string;
};

export type ElectronicIdHubData = AudkenniAppHubData | PkiSimHubData;

export type OnReceiveVerificationDataCallback<T> = (data: T) => void;
export type OnReceiveSuccessCallback = (callbackUrl: string) => void;
export type OnReceiveErrorCallback = (message: string) => void;

export interface IElectronicIdHubServiceListener<T> {
  onReceiveVerificationData(
    callback: OnReceiveVerificationDataCallback<T>,
  ): void;
  onReceiveSuccess(callback: OnReceiveSuccessCallback): void;
  onReceiveError(callback: OnReceiveErrorCallback): void;
}

export enum ElectronicIdHubServiceEvents {
  ReceiveSuccessAsync = 'ReceiveSuccessAsync',
  ReceiveVerificationDataAsync = 'ReceiveVerificationDataAsync',
}

export interface IElectronicIdHubService<T>
  extends IHubService,
    IElectronicIdHubServiceListener<T> {}

export class ElectronicIdHubService<T>
  extends HubService
  implements IElectronicIdHubService<T>
{
  constructor() {
    super({
      path: '/hubs/electronicid',
      logger: LoggerServiceFactory.create('ElectronicIdHubService'),
    });
  }

  public onReceiveError(callback: (message: string) => void): string {
    return this.on(HubServiceEvents.ReceiveErrorAsync, callback);
  }

  public onReceiveSuccess(callback: (callbackUrl: string) => void): string {
    return this.on(ElectronicIdHubServiceEvents.ReceiveSuccessAsync, callback);
  }

  public onReceiveVerificationData(callback: (data: T) => void): string {
    return this.on(
      ElectronicIdHubServiceEvents.ReceiveVerificationDataAsync,
      callback,
    );
  }
}

export const ElectronicIdHubServiceToken = Symbol(ElectronicIdHubService.name);
